// extracted by mini-css-extract-plugin
export default {"TeamBlock":"team_TeamBlock__hVVTz","TeamContainer":"team_TeamContainer__Ulf+0","teammateImg":"team_teammateImg__+1OSq","waveUp":"team_waveUp__LfhzJ"};